<app-loader></app-loader>
<header 
  class="encabezado bg-white">
  <div class="encabezado-superior">
    <div class="logotipo-seccion">
      <span class="icono-bolsa pointer" (click)="irInicio()"><i class="fa-solid fa-bag-shopping"></i></span>
      <h1 class="nombre-app pointer" (click)="irInicio()">Colpraz!</h1>
    </div>
    <div class="usuario-estatus">
      <span class="badge-carrito pointer" (click)="funciones.irAlMarcador('seccion-cesta')"><i class="fa-solid fa-cart-shopping"></i> {{getProductosCheck('X').length}}/{{productos.length || 0}}</span>
      <app-user></app-user>
    </div>
  </div>
</header>
<header *ngIf="isScrolled"
  class="encabezado fixed-top div-agua efecto-arriba-abajo">
  <div class="encabezado-superior">
    <div class="logotipo-seccion">
      <a class="pointer" href="{{global.urlServer}}"><span class="icono-bolsa"><i class="fa-solid fa-bag-shopping"></i></span></a>
      <h1 class="nombre-app">Colpraz!</h1>
    </div>
    <div class="usuario-estatus">
      <span class="badge-carrito pointer" (click)="funciones.irAlMarcador('seccion-cesta')"><i class="fa-solid fa-cart-shopping"></i> {{getProductosCheck('X').length}}/{{productos.length || 0}}</span>
      <app-user></app-user>
    </div>
  </div>
</header>